<template>
  <v-autocomplete
    :items="items"
    item-text="descricao_full"
    item-value="id"
    v-bind="$attrs"
    v-bind:value="modelValue"
    v-on="inputListeners"
    :loading="loading"
  >
    <template #progress>
      <v-progress-linear
        style="position: absolute"
        height="2px"
        :color="cor_loading"
        indeterminate
      />
    </template>

    <template #prepend-item v-if="!desativarSelecionarTodos && multiplaSelecao && items.length">
      <v-list-item
        v-if="modelValue.length === items.length"
        class="py-2"
        @click="updateModel([])"
      >
        <v-icon class="ml-2" color="primary">mdi-checkbox-marked</v-icon>
        <span class="ml-2 font-weight-medium">Desmarcar Todos</span>
      </v-list-item>

      <v-list-item
        v-else
        class="py-2"
        @click="updateModel(Helpers.arrayColumn(items, 'id'))"
      >
        <v-icon v-if="modelValue.length > 0" class="ml-2" color="primary">mdi-minus-box</v-icon>
        <v-icon v-else class="ml-2">mdi-checkbox-blank-outline</v-icon>
        <span class="ml-2 font-weight-medium">Selecionar Todos</span>
      </v-list-item>

      <v-divider />
    </template>

    <template #selection="{item}" v-if="multiplaSelecao">
      <template v-if="modelValue.indexOf(item.id) < qtdeVisivelSelecionados">
        <span>{{item.descricao}}</span><template v-if="apendarVirgula(item)">,&nbsp;</template>
      </template>

      <template v-if="modelValue.indexOf(item.id) === qtdeVisivelSelecionados">
        <span class="ml-1 text-grat-900">(+ {{modelValue.length - qtdeVisivelSelecionados}})</span>
      </template>
    </template>

    <template v-for="(_, slot) of $scopedSlots" #[slot]="scope">
      <slot :name="slot" v-bind="scope"/>
    </template>

    <template #prepend-inner>
      <slot name="prepend-inner" />
    </template>
  </v-autocomplete>
</template>

<script>
import api from "@/api/api.js";
import { logout } from "@/helpers/index.js";

export default {
  name: "SysFornecedorFabricanteAutocomplete",
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: {
      type: [Number, String, Array],
      required: true
    },
    idpedido: {
      type: Number,
      required: true
    },
    idfabricante: {
      type: Number,
      required: true
    },
    analiseGrupoFornecedores: {
      type: String,
      required: true
    },
    qtdeVisivelSelecionados: {
      type: [Number],
      default: 4
    },
    desativarSelecionarTodos: {
      type: Boolean,
      default: false
    },
    cor_loading: {
      type: String,
      default: 'red'
    },
  },
  data: () => ({
    items: [],
    loading: false,
  }),
  computed: {
    multiplaSelecao () {
      return ![null, undefined].includes(this.$attrs.multiple)
    },
    inputListeners: function () {
      const vm = this

      return Object.assign({},
        vm.$listeners, {
          input: function (values) {
            if ([null, undefined].includes(values)) {
              values = vm.$attrs.multiple ? [] : '';
            }

            vm.updateModel(values)
          }
        }
      )
    }
  },
  mounted() {
    this.getItems();
  },
  methods: {
    updateModel(values) {
      if ([null, undefined].includes(values)) {
        values = this.$attrs.multiple ? [] : '';
      }

      this.$emit('update:modelValue', values)
    },
    getItems () {
      this.loading = true;

      const params = {
        idpedido: this.idpedido,
        fabricante: this.idfabricante,
        analiseGrupoFornecedores: this.analiseGrupoFornecedores
      };

      api.get('get_fornecedor_fabricante', { params })
        .then(response => {
          this.items = response.data.forneFabri.map(item => ({
            id: item.idfornecedor,
            descricao_full: `${item.cnpj} - ${item.razao_social} (${item.idfornecedor})`,
          }));

          this.loading = false;
        })
        .catch(logout)
    },
    apendarVirgula (item) {
      const indexOf = this.modelValue.indexOf(item.id)
      return indexOf !== this.modelValue.length - 1 && indexOf < (this.qtdeVisivelSelecionados - 1)
    }
  }
}
</script>

<style scoped>
.pl-14px {
  padding-left: 14px
}
.text-grat-900 {
  color: #999;
}
</style>
